import { fabric } from 'fabric';
import DEFINE from '../define';
import ToolBase from '../basic';
import rotate_btn from '../../../assets/art/math_tool/polygon/rotateBtn.svg';
import scaleIcon from '../../../assets/control/scale_icon.svg';
import { focusStore } from '../../store/nowFocusStore';


export default class AngleTool extends ToolBase {

    name = DEFINE.TOOLS.ANGLE_TOOL;

    originPosition = new fabric.Point(600, 550);

    targetTag = "";
    originPointer = null;
    offset = new fabric.Point(0, 0);
    btnOrig = null;

    origWidth = 600;


    // 角度工具
    angle_tool = null;
    rotate_btn = null;
    horizontal = null;
    angleLine = null;
    sector = null;
    arc = null;
    angleText = null;
    distanceRotateToCenter = 180;

    //角度
    angle = 90;
    //紀錄前次角度
    preAngle;
    //線段長度
    lineLength = 150;

    /**
     *
     * @type {fabric.Group}
     * @memberof AngleTool
     */
    scaleButton = null;
    /**
     * is scaling angle tool
     * @type {boolean}
     * @memberof AngleTool
     */
    isScaling = false;

    scaleBaseLength = 0;

    preScaleLength = 0;
    preScale = 1;

    currentAngleToolScale = 0;

    rotationButton = null;

    closeButton = null;

    constructor(parent) {
        super(parent);
    }

    create() {
        super.create();

        const self = this;
        this.originPosition.x = focusStore.mainBookPage.pagePercentPoint.x * this.parent.canvas.width;
        this.originPosition.y = focusStore.mainBookPage.pagePercentPoint.y * this.parent.canvas.height;

        let origX = self.originPosition.x;
        let origY = self.originPosition.y;

        let value = this.angle;

        // 限制只能生成一個
        this.canvas.getObjects().forEach(object => {
            if (object && (object.tag || "").indexOf(DEFINE.TAG.ANGLE_TOOL) == 0) {
                self.canvas.remove(object);
            }
        });

        //載入旋轉按鈕
        fabric.loadSVGFromURL(rotate_btn, (objects, options) => {
            self.rotate_btn = new fabric.util.groupSVGElements(objects, options);

            //計算按鈕座標
            let slope = Math.tan(-value * (Math.PI / 180));

            //以斜率及距離求新座標
            let deltaX = self.distanceRotateToCenter / Math.sqrt(Math.pow(slope, 2) + 1);
            let deltaY = deltaX * slope;

            if (value > 90 && value < 270) {
                deltaX = -deltaX;
                deltaY = -deltaY;
            }

            self.rotate_btn.set({
                tag: DEFINE.TAG.ANGLE_TOOL_ROTATE_BTN + new Date().getTime(),
                left: self.originPosition.x + deltaX,
                top: self.originPosition.y + deltaY,
                angle: -value,
                scaleX: 0.1,
                scaleY: 0.1,
                originX: "center",
                originY: "center",
            });

            //產生水平線
            self.horizontal = new fabric.Line([origX, origY, origX + self.lineLength, origY], {
                tag: DEFINE.TAG.ANGLE_TOOL_HORIZONTAL + new Date().getTime(),
                stroke: DEFINE.COLOR.MATH_TOOL.BLACK_0_0_0,
                strokeWidth: 5,
                originX: "left",
                originY: "center"
            });

            //產生對應角度線
            self.angleLine = new fabric.Line([origX + 2.5, origY, origX + self.lineLength, origY], {
                tag: DEFINE.TAG.ANGLE_TOOL_ANGLE_LINE + new Date().getTime(),
                angle: -value,
                stroke: DEFINE.COLOR.MATH_TOOL.BLACK_0_0_0,
                strokeWidth: 5,
                originX: "left",
                originY: "center"
            });

            //產生扇形
            let r = 30;
            self.sector = new fabric.Circle({
                tag: DEFINE.TAG.ANGLE_TOOL_SECTOR + new Date().getTime(),
                radius: r,
                left: origX,
                top: origY,
                angle: -value,
                startAngle: 0,
                endAngle: value,
                fill: DEFINE.COLOR.TRANSPARENT,
                stroke: DEFINE.COLOR.MATH_TOOL.BLUE_0_175_239,
                strokeWidth: r * 2,
                originX: "center",
                originY: "center"
            });

            //產生弧線        
            self.arc = new fabric.Circle({
                tag: DEFINE.TAG.ANGLE_TOOL_ARC + new Date().getTime(),
                radius: 140,
                left: origX,
                top: origY,
                angle: -value,
                startAngle: 0,
                endAngle: value,
                fill: DEFINE.COLOR.TRANSPARENT,
                stroke: DEFINE.COLOR.MATH_TOOL.BLUE_0_31_95,
                strokeWidth: 5,
                originX: "center",
                originY: "center"
            });

            //產生角度文字
            self.angleText = new fabric.Text(value + "°", {
                tag: DEFINE.TAG.ANGLE_TOOL_ANGLE_TEXT + new Date().getTime(),
                left: origX - 25,
                top: (value < 180) ? origY + 10 : origY - 50,
                fontFamily: "Arial",
                fill: DEFINE.COLOR.MATH_TOOL.BLUE_0_31_95,
            });

            let rectangle = new fabric.Rect({
                left: origX,
                top: origY,
                width: self.origWidth,
                height: self.origWidth,
                originX: "center",
                originY: "center",
                visible: false
            });

            //將產生的物件群組
            self.angle_tool = new fabric.Group([rectangle, self.sector, self.arc, self.horizontal, self.angleLine, self.angleText, self.rotate_btn], {
                tag: DEFINE.TAG.ANGLE_TOOL + new Date().getTime(),
                toolType: self.name,
                selectionActive: true,
                originX: 'center',
                originY: 'center',
                perPixelTargetFind: true,
                selectable: true,
                hasBorders: false,
                hasControls: false,
                subTargetCheck: true,    //讓子物件可以個別觸發事件
                lockScalingFlip: true,
            });


            self.registerEvent(self.angle_tool);

            // 載入縮放按鈕
            fabric.loadSVGFromURL(scaleIcon, (objects, options) => {
                self.scaleButton = new fabric.util.groupSVGElements(objects, options);

                self.scaleButton.set({
                    tag: DEFINE.TAG.ANGLE_TOOL_ANGLE_SCALE + new Date().getTime(),
                    left: self.angle_tool.getScaledWidth() * 0.5 - self.scaleButton.getScaledWidth() * 0.1,
                    top: -self.scaleButton.getScaledHeight() * 0.1 * 0.55,
                    scaleX: 0.1,
                    scaleY: 0.1,
                    originX: "left",
                    originY: "top",
                });


                const scaleButtonPoint = new fabric.Point(self.scaleButton.left + self.scaleButton.getScaledWidth() * 0.5, self.scaleButton.top + self.scaleButton.getScaledHeight() * 0.5);

                self.scaleBaseLength = scaleButtonPoint.distanceFrom(new fabric.Point(0, 0));

                self.angle_tool.add(self.scaleButton);

                fabric.loadSVGFromURL(this.deleteIcon, (objects, options) => {
                    self.closeButton = new fabric.util.groupSVGElements(objects, options);
                    self.closeButton.set({
                        tag: DEFINE.TAG.ANGLE_TOOL_CLOSE_BUTTON + new Date().getTime(),
                        left: self.angle_tool.getScaledWidth() * 0.5 - self.closeButton.getScaledWidth() * 0.225,
                        top: -self.closeButton.getScaledHeight() * 0.1 * 0.55,
                        scaleX: 0.1,
                        scaleY: 0.1,
                        originX: "left",
                        originY: "top",
                    });

                    self.angle_tool.add(self.closeButton);

                    fabric.loadSVGFromURL(this.touchRotateIcon, (objects, options) => {
                        self.rotationButton = new fabric.util.groupSVGElements(objects, options);

                        self.rotationButton.set({
                            tag: DEFINE.TAG.ANGLE_TOOL_ANGLE_ROTATION + new Date().getTime(),
                            left: self.angle_tool.getScaledWidth() * 0.5 - self.rotationButton.getScaledWidth() * 0.225,
                            top: self.rotationButton.getScaledHeight() * 0.1 * 0.55,
                            scaleX: 0.1,
                            scaleY: 0.1,
                            originX: "left",
                            originY: "top",
                        });

                        self.angle_tool.add(self.rotationButton);

                        self.scaledAngleTool();

                        self.canvas.add(self.angle_tool);
                        self.canvas.renderAll();
                    })

                })
            })

        });
    }

    setValue(value) {
        super.setValue(value);

        this.angle = value;
    }

    recover(object) {
        let tag = object.tag;

        if (tag.includes(DEFINE.TAG.ANGLE_TOOL)) {
            this.angle_tool = object;
            this.angle_tool["_objects"].forEach(e => {
                if (e.tag && e.tag.includes(DEFINE.TAG.ANGLE_TOOL_ROTATE_BTN)) {
                    this.rotate_btn = e;
                } else if (e.tag && e.tag.includes(DEFINE.TAG.ANGLE_TOOL_SECTOR)) {
                    this.sector = e;
                } else if (e.tag && e.tag.includes(DEFINE.TAG.ANGLE_TOOL_ARC)) {
                    this.arc = e;
                } else if (e.tag && e.tag.includes(DEFINE.TAG.ANGLE_TOOL_ANGLE_TEXT)) {
                    this.angleText = e;
                } else if (e.tag && e.tag.includes(DEFINE.TAG.ANGLE_TOOL_ANGLE_LINE)) {
                    this.angleLine = e;
                } else if (e.tag && e.tag.includes(DEFINE.TAG.ANGLE_TOOL_HORIZONTAL)) {
                    this.horizontal = e;
                }else if (e.tag && e.tag.includes(DEFINE.TAG.ANGLE_TOOL_ANGLE_SCALE)) {
                    this.scaleButton = e;
                }else if (e.tag && e.tag.includes(DEFINE.TAG.ANGLE_TOOL_ANGLE_ROTATION)) {
                    this.rotationButton = e;
                }else if (e.tag && e.tag.includes(DEFINE.TAG.ANGLE_TOOL_CLOSE_BUTTON)) {
                    this.closeButton = e;
                }
            });

            this.angle_tool.set({
                hasBorders: false,
                hasControls: false
            });


            this.registerEvent(object);
        }
    }

    mouseUp(o) {
        if (this.targetTag.includes(DEFINE.TAG.ANGLE_TOOL_ROTATE_BTN) || this.targetTag.includes(DEFINE.TAG.ANGLE_TOOL_ANGLE_SCALE) || this.targetTag.includes(DEFINE.TAG.ANGLE_TOOL_ANGLE_ROTATION)) {
            this.targetTag = "";
            this.angle_tool.set('lockMovementX', false);
            this.angle_tool.set('lockMovementY', false);
        }
        
        this.isScaling = false;
        this.preScale = this.angle_tool.scaleX;
    }

    mouseDown(o) {
        if (o.target) {
            if (o.target.tag) {
                if (o.target.tag.includes(DEFINE.TAG.ANGLE_TOOL)) {
                    this.angle_tool.set('lockMovementX', false);
                    this.angle_tool.set('lockMovementY', false);

                    if (o.subTargets[0] && o.subTargets[0].tag) {
                        this.targetTag = o.subTargets[0].tag;
                    } else {
                        this.targetTag = o.target.tag;
                    }

                    this.originPointer = o.pointer;

                    this.switchControls(true);
                }
            }
        }

        this.angle_tool.canvas._activeObject = this.angle_tool;

        if (this.targetTag.includes(DEFINE.TAG.ANGLE_TOOL_ROTATE_BTN) || this.targetTag.includes(DEFINE.TAG.ANGLE_TOOL_ANGLE_ROTATION)) {
            this.angle_tool.set('lockMovementX', true);
            this.angle_tool.set('lockMovementY', true);
        } else if (this.targetTag.includes(DEFINE.TAG.ANGLE_TOOL_ANGLE_SCALE)) {
            this.angle_tool.set('lockMovementX', true);
            this.angle_tool.set('lockMovementY', true);
            this.isScaling = true;

            const pointer = this.canvas.getPointer(o.e);

            const center = new fabric.Point(this.angle_tool.left, this.angle_tool.top);

            const newPoint = new fabric.Point(pointer.x - center.x, pointer.y - center.y + this.scaleButton.getScaledHeight() * 0.5);

            const newDistance = newPoint.distanceFrom(new fabric.Point(0, 0));

            console.log(`point down newDistance:: ${newDistance}`);

            this.preScaleLength = newDistance;
            this.currentAngleToolScale = this.preScaleLength / this.scaleBaseLength;
        }else if(this.targetTag.includes(DEFINE.TAG.ANGLE_TOOL_CLOSE_BUTTON)) {
            this.canvas.remove(this.angle_tool);
            this.canvas.requestRenderAll();
            this.parent.currentTool = null;
            this.parent.addHistory();
        }

        this.canvas.renderAll();
    }

    mouseMove(o) {
        if (!this.targetTag.includes(DEFINE.TAG.ANGLE_TOOL)) return;

        if (this.targetTag.includes(DEFINE.TAG.ANGLE_TOOL_ROTATE_BTN)) {
            this.angleChange(o.pointer);
        } else if (this.targetTag.includes(DEFINE.TAG.ANGLE_TOOL_ANGLE_SCALE)) {
            this.scaleAngleTool(this.canvas.getPointer(o.e));
        } else if(this.targetTag.includes(DEFINE.TAG.ANGLE_TOOL_ANGLE_ROTATION)) {
            this.rotatingAngleTool(this.canvas.getPointer(o.e));
        } else {
            this.offset = new fabric.Point(o.pointer.x - this.originPointer.x, o.pointer.y - this.originPointer.y);
        }

        this.canvas.renderAll();
    }

    //拖曳角度線函式
    angleChange(newPoint) {
        let temp_angle = this.angle_tool.angle;
        this.angle_tool.angle = 0;
        //計算圓心
        // let center = new fabric.Point(this.angle_tool.left + this.angle_tool.width / 2, this.angle_tool.top + this.angle_tool.height / 2);
        let center = new fabric.Point(this.angle_tool.left, this.angle_tool.top);
        //計算斜率
        let slope = (newPoint.y - center.y) / (newPoint.x - center.x);
        let angle = (Math.atan(slope) / (Math.PI / 180));

        //同方向移動會根據是否超過180度而決定增減
        if (newPoint.x < center.x)
            angle += 180;

        angle -= temp_angle;

        if (-angle < 0) {
            angle -= 360;
        }

        if (-angle > 360) {
            angle = (360 + angle);
        }


        //刷新按鈕位置
        this.angle_tool.removeWithUpdate(this.rotate_btn);
        //以斜率及距離求新座標
        let newSlope = Math.tan(angle * (Math.PI / 180));
        let distance = this.distanceRotateToCenter * this.angle_tool.width / this.origWidth;
        let deltaX = distance / Math.sqrt(Math.pow(newSlope, 2) + 1);
        let deltaY = deltaX * newSlope;

        if (-angle > 90 && -angle < 270) {
            deltaX = -deltaX;
            deltaY = -deltaY;
        }

        this.rotate_btn.set({
            left: center.x + deltaX,
            top: center.y + deltaY,
            angle: angle,
        });

        this.angle_tool.addWithUpdate(this.rotate_btn);

        //重畫角度線
        this.angleLine.set({
            angle: angle
        });

        //重畫扇形
        this.sector.set({
            angle: angle,
            endAngle: -angle
        });

        //重畫弧線
        this.arc.set({
            angle: angle,
            endAngle: -angle
        });

        //重寫角度文字
        this.angleText.set('text', parseInt(-angle) + "°");
        let textHeight = this.angleText.height * this.angleText.scaleX * 1.3;

        if (this.preAngle <= 180 && -angle > 180) {
            this.angleText.set({
                top: this.angleText.top - textHeight,
            });
        } else if (this.preAngle > 180 && -angle <= 180) {
            this.angleText.set({
                top: this.angleText.top + textHeight,
            });
        }

        this.preAngle = -angle;

        //重置實際座標位置
        this.angleLine.setCoords();
        this.angle_tool.setCoords();

        //重新加入角度線以重置群組
        // this.angle_tool.removeWithUpdate(this.angleLine);
        // this.angle_tool.addWithUpdate(this.angleLine);

        // let temp_angle = this.angle_tool.angle;
        this.angle_tool.angle = temp_angle;

        this.canvas.renderAll();

    }

    angleScaler(eventData, transform, x, y) {
        var target = transform.target;


        const center = new fabric.Point(target.left, target.top);
        const newPoint = new fabric.Point(x, y);
        const newDistance = newPoint.distanceFrom(center);

        if (!target.currentScale) {
            target.currentScale = target.scaleX;
            target.preScaleDistance = newDistance;
        }

        const deltaScale = (newDistance - target.preScaleDistance) / this.scaleBaseLength;
        const scale = Math.min(Math.max(target.currentScale + deltaScale, 0.6), 1.5);

        // var scale = Math.max(newPoint.distanceFrom(center) / target.firstDistance, 0.7);

        // console.log(`scale:: ${scale}, "first distance: ${target.firstDistance}`);
        var oldScaleX = target.scaleX, oldScaleY = target.scaleY;

        target.set('scaleX', scale);
        target.set('scaleY', scale);

        return oldScaleX !== target.scaleX || oldScaleY !== target.scaleY;
    }
    /**
     * 
     * @param {fabric.object} group 
     */
    registerEvent(group) {
        this.btnOrig = new fabric.Point(this.rotate_btn.left, this.rotate_btn.top);

        const self = this;
    }

    //#region scale angle tool
    scaleAngleTool(pointer) {
        if (!this.isScaling) return;
        const center = new fabric.Point(this.angle_tool.left, this.angle_tool.top);

        const newPoint = new fabric.Point(pointer.x - center.x, pointer.y - center.y + this.scaleButton.getScaledHeight() * 0.5);

        const newDistance = newPoint.distanceFrom(new fabric.Point(0, 0));

        const deltaScale = (newDistance - this.preScaleLength) / this.scaleBaseLength;

        const scaleRate = this.preScale / this.currentAngleToolScale;

        const scale = Math.min(Math.max(this.preScale + (deltaScale * scaleRate), 0.6 * scaleRate), 2 * scaleRate);

        const buttonScale = 0.1 / scale;

        this.angle_tool.set({
            scaleX: scale,
            scaleY: scale,
        });

        this.rotate_btn.set({
            scaleX: buttonScale,
            scaleY: buttonScale,
        });
        this.scaleButton.set({
            scaleX: buttonScale,
            scaleY: buttonScale,
        });
        this.rotationButton.set({
            scaleX: buttonScale,
            scaleY: buttonScale,
        })
        this.closeButton.set({
            scaleX: buttonScale,
            scaleY: buttonScale,
        })
        
        this.scaleButton.set({
            left: this.angle_tool.getScaledWidth() * 0.5 / scale - this.scaleButton.getScaledWidth(),
            top: -this.scaleButton.getScaledHeight() * 0.55
        });
        this.rotationButton.set({
            left: this.angle_tool.getScaledWidth() * 0.5 / scale - this.rotationButton.getScaledWidth() * 2.25,
            top: this.rotationButton.getScaledHeight() * 0.55
        });
        this.closeButton.set({
            left: this.angle_tool.getScaledWidth() * 0.5 / scale - this.closeButton.getScaledWidth() * 2.25,
            top: -this.closeButton.getScaledHeight() * 0.55
        });

        this.closeButton.setCoords();
        this.rotationButton.setCoords();
        this.scaleButton.setCoords();
        this.angle_tool.setCoords();

        this.canvas.renderAll();
    }
    scaledAngleTool() {
        this.angle_tool.removeWithUpdate(this.scaleButton);
        this.angle_tool.addWithUpdate(this.scaleButton);

        this.closeButton.setCoords();
        this.rotationButton.setCoords();
        this.scaleButton.setCoords();
        this.angle_tool.setCoords();
        this.canvas.renderAll();
    }
    //#endregion

    //#region rotate angle tool
    rotatingAngleTool(pointer) {
        const center = new fabric.Point(this.angle_tool.left, this.angle_tool.top);

        //計算斜率
        let slope = (pointer.y - center.y) / (pointer.x - center.x);
        let angle = (Math.atan(slope) / (Math.PI / 180));

        if (pointer.x < center.x)
            angle += 180;

        this.angle_tool.angle = angle;

        this.canvas.renderAll();
    }
    //#endregion
    
    //#region angle tool controls
    /**
     * 
     * @param {boolean} show 
     */
    switchControls(show) {
        this.scaleButton.set({
            visible: show
        })
        this.rotationButton.set({
            visible: show
        })
        this.closeButton.set({
            visible: show
        })

        this.canvas.renderAll();
    }
    //#endregion
}